import React from 'react';
import { useNavigate } from 'react-router-dom';

const DEALS = [
  { route: 'NYC → LAX', price: '$89',  airline: 'United',   drop: '62%' },
  { route: 'MIA → ORD', price: '$71',  airline: 'American', drop: '55%' },
  { route: 'DAL → SFO', price: '$94',  airline: 'Southwest',drop: '48%' },
  { route: 'ATL → LAS', price: '$79',  airline: 'Delta',    drop: '60%' },
  { route: 'BOS → DEN', price: '$83',  airline: 'JetBlue',  drop: '51%' },
  { route: 'SEA → PHX', price: '$67',  airline: 'Alaska',   drop: '57%' },
];

export default function DealStrip() {
  const navigate = useNavigate();
  return (
    <div className="bg-[#0a0f2e] py-4 overflow-hidden border-b border-blue-900">
      <div className="flex items-center gap-0">
        <span className="shrink-0 bg-yellow-400 text-blue-900 text-xs font-black px-4 py-2 z-10">🔥 LIVE DEALS</span>
        <div className="flex gap-6 overflow-x-auto scrollbar-hide px-4 pb-1" style={{ scrollbarWidth: 'none' }}>
          {[...DEALS, ...DEALS].map((d, i) => (
            <button key={i} onClick={() => navigate('/flights')}
              className="shrink-0 flex items-center gap-2 text-white hover:text-yellow-300 transition-colors text-sm">
              <span className="font-bold">{d.route}</span>
              <span className="text-cyan-400 font-black">{d.price}</span>
              <span className="text-green-400 text-xs bg-green-400/10 px-1.5 py-0.5 rounded">↓{d.drop}</span>
              <span className="text-white/30 text-xs">{d.airline}</span>
              <span className="text-white/20">|</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
